"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteRiskMemberApi = deleteRiskMemberApi;
var _request = _interopRequireDefault(require("@/utils/request"));
// 风险用户设置为正常
function deleteRiskMemberApi(data) {
  return (0, _request.default)({
    url: '/portal/system/member/deleteRiskMember',
    method: 'post',
    data: data
  });
}